import React from 'react';
import { useNavigate } from 'react-router-dom';

export interface BreadCrumbItem {
    label: string;
    url?: string;
}

function BreadCrumb({ items }: { items: BreadCrumbItem[] }) {
    const navigate = useNavigate();

    return (
        <nav>
            <ol className="breadcrumb">
                <li className="breadcrumb-item cursor-pointer" onClick={() => navigate('/dashboard')} >
                    <span>Home</span>
                </li>
                {items.map((item, index) => {
                    const isLast: boolean = index === items.length - 1;

                    return (isLast || !item.url) ? (
                        <li key={index} className="breadcrumb-item active">{item.label}</li>
                    ) : (
                        <li key={index} className="breadcrumb-item cursor-pointer" onClick={() => navigate(item.url!)}>
                            <span>{item.label}</span>
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}

export default BreadCrumb;